module.exports = __webpack_public_path__ + "static/media/cv-katarzyna-zukowska.e343ab4e.pdf";